import axios from 'axios'
import qs from 'qs'
import { Toast } from 'antd-mobile'
import { getParams, setLogin } from './utils'
import { featchDataApp } from './encryption/aesTools.js'

const axiosService = { timeout: 20000 }
// if (process.env.REACT_APP_TYPE !== 'localhost') {
//   axiosService.baseURL = process.env.REACT_APP_API_URL
// }

const service = axios.create(axiosService)
service.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

const loading = document.querySelector('.page-loading')

// 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
// 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
service.defaults.transformRequest = [
    function (data, headers) {
        const { 'Content-Type': ct } = headers
        if (data instanceof FormData) {
            return data
        } else if (/application\/json/gi.test(ct)) {
            return JSON.stringify(data)
        } else {
            return qs.stringify(data)
        }
    }
]
service.interceptors.request.use(
    config => {
        loading.style.display = 'block'
        loading.style.opacity = 1
        loading.style.zIndex = 999
        config.headers.plant = 'H5'
        config.headers['Cache-Control'] = 'no-cache'
        // 注释掉原有逻辑
        // if (config.method === 'post') {
        //     config.data = qs.stringify(config.data)
        // }

        // 预览的时候不取token,删除cookie,直接返回
        const params = getParams()
        if (params.isPreview === 'true') {
            document.cookie = 'sessionId=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            return config
        }
        return config
    },
    error => {
        console.log(error)
        console.log('请求拦截错误')
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        console.log(response, 'response.dresponse.dataresponse.dataata')
        const res = response.data
        loading.style.opacity = 0
        loading.style.zIndex = -1
        setTimeout(() => {
            loading.style.display = 'none'
        }, 500)
        if (res.code === '401') {
            document.cookie = 'sessionId=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            setLogin()
            Toast.fail(res.msg, 1)
            return response
        } else if (res.code !== '200') {
            Toast.fail(res.msg, 1)
            return Promise.reject(res.showMessage)
        } else {
            return response.data
        }
    },
    error => {
        loading.style.opacity = 0
        loading.style.zIndex = -1
        setTimeout(() => {
            loading.style.display = 'none'
        }, 500)
        if (error.response && error.response.status === 401) {
            setLogin()
            Toast.fail('用户未登录', 1)
        } else if (error.response && error.response.status === 500) {
            Toast.fail('系统错误!', 1)
        } else if (error.message && error.message.indexOf('timeout') > -1) {
            Toast.fail('网络超时!', 1)
        } else if (error === '403') {
            Toast.fail('没有请求权限', 1)
        } else {
            Toast.offline('网络错误', 1)
        }
        return Promise.reject(error)
    }
)

// export default service

export default {
    post (url, data) {
        return featchDataApp({
            method: 'post',
            url: url,
            options: data.params,
            headers: data.headers
        })
            .then((result) => {
                const status = result.status
                const resultCode = result.data.code
                if (
                    status === '200' || resultCode === '200'
                ) {
                    return Promise.resolve(result.data)
                } else {
                    Toast.makeText(result.data.resultMsg).show()
                    return result.data
                }
            })
            .catch((checkCodeMsg) => {
                return Promise.reject(checkCodeMsg)
            })
    },
    get (url, data) {
        return featchDataApp({
            method: 'get',
            url: url,
            options: data.params,
            headers: data.headers
        })
            .then((res) => {
                loading.style.opacity = 0
                loading.style.zIndex = -1
                setTimeout(() => {
                    loading.style.display = 'none'
                }, 500)
                if (res.code === '401') {
                    // document.cookie = 'sessionId=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
                    setLogin()
                    Toast.fail(res.msg, 1)
                    return Promise.resolve(res)
                } else if (res.code !== '200') {
                    Toast.fail(res.msg, 1)
                    return Promise.reject(res.showMessage)
                } else {
                    return Promise.resolve(res)
                }
            })
            .catch((error) => {
                loading.style.opacity = 0
                loading.style.zIndex = -1
                setTimeout(() => {
                    loading.style.display = 'none'
                }, 500)
                // if (error && error.status === 401) {
                //     setLogin()
                //     Toast.fail('用户未登录', 1)
                // } else if (error && error.status === 500) {
                //     Toast.fail('系统错误!', 1)
                // } else if (error.message && error.message.indexOf('timeout') > -1) {
                //     Toast.fail('网络超时!', 1)
                // } else if (error === '403') {
                //     Toast.fail('没有请求权限', 1)
                // } else {
                //     Toast.offline('网络错误', 1)
                // }
                return Promise.reject(error)
            })
    }
}
